module.exports = __webpack_public_path__ + "smoke-blurred-48e35444d0ee521a13dc5244d5358f84.png";


//////////////////
// WEBPACK FOOTER
// ./app/frontend/img/smoke-blurred.png
// module id = 497
// module chunks = 0